export const DIMENSIONS = {
  genders: ['MALE', 'FEMALE', 'UNDETERMINED'],
  age_ranges: ['AGE_RANGE_18_24', 'AGE_RANGE_25_34', 'AGE_RANGE_35_44', 'AGE_RANGE_45_54', 'AGE_RANGE_55_64', 'AGE_RANGE_65_UP', 'AGE_RANGE_UNDETERMINED'],
  income_ranges: ['INCOME_RANGE_0_50', 'INCOME_RANGE_50_60', 'INCOME_RANGE_60_70', 'INCOME_RANGE_70_80', 'INCOME_RANGE_80_90', 'INCOME_RANGE_90_UP', 'INCOME_RANGE_UNDETERMINED'],
  parental_statuses: ['PARENT', 'NOT_A_PARENT', 'UNDETERMINED'],
};
export const LABELS = { genders: 'Gender', age_ranges: 'Age', income_ranges: 'Household income', parental_statuses: 'Parental status',
  MALE: 'Male', FEMALE: 'Female', UNDETERMINED: 'Unknown', PARENT: 'Parent', NOT_A_PARENT: 'Not a parent',
  AGE_RANGE_18_24: '18–24', AGE_RANGE_25_34: '25–34', AGE_RANGE_35_44: '35–44', AGE_RANGE_45_54: '45–54', AGE_RANGE_55_64: '55–64', AGE_RANGE_65_UP: '65+', AGE_RANGE_UNDETERMINED: 'Unknown',
  INCOME_RANGE_0_50: 'Lower 50%', INCOME_RANGE_50_60: '41–50%', INCOME_RANGE_60_70: '31–40%', INCOME_RANGE_70_80: '21–30%', INCOME_RANGE_80_90: '11–20%', INCOME_RANGE_90_UP: 'Top 10%', INCOME_RANGE_UNDETERMINED: 'Unknown' };
export const toggle = (list, value) => list.includes(value) ? list.filter(x => x !== value) : [...list, value];
export function candidatesFor(input, catalog) {
  if (input.kind === 'new_custom_segment') return [];
  const list = input.kind === 'custom_audience' ? catalog?.custom_audiences : catalog?.interests;
  const needle = input.value.trim().toLowerCase();
  const words = needle.split(/\W+/).filter(x => x.length > 1 && !['and', 'the', 'for', 'to', 'of'].includes(x));
  const score = item => {
    const name = item.name.toLowerCase();
    const tokens = new Set(name.split(/\W+/));
    const overlap = words.filter(w => tokens.has(w)).length;
    return (item.id === input.selectedId ? 10000 : 0) + (name === needle || item.id === needle ? 1000 : 0) + (needle && name.includes(needle) ? 100 : 0) + overlap;
  };
  return (list || []).filter(x => score(x) > 0).sort((a,b) => score(b) - score(a) || a.name.localeCompare(b.name)).slice(0, 30);
}
// Only an unambiguous catalogue name/ID match is automatic. Related matches
// remain suggestions and existing user selections always take precedence.
export function selectExactMatch(input, catalog) {
  if (!input.included || input.selectedId || input.kind === 'new_custom_segment') return input;
  const pool = input.kind === 'custom_audience' ? catalog?.custom_audiences : catalog?.interests;
  const needle = input.value.trim().toLowerCase();
  const exact = (pool || []).filter(x => x.name.trim().toLowerCase() === needle || x.id === needle);
  return exact.length === 1 ? { ...input, selectedId: exact[0].id } : input;
}
export function selectExactMatches(draft, catalog) {
  if (!draft) return draft;
  let changed = false;
  const tests = draft.tests.map(t => ({ ...t, inputs: t.inputs.map(i => {
    const next = selectExactMatch(i, catalog);
    changed ||= next !== i;
    return next;
  }) }));
  return changed ? { ...draft, tests } : draft;
}
export function separateTestFor(draft, source, input) {
  const key = i => i.kind === 'new_custom_segment'
    ? JSON.stringify([i.kind, i.segmentType, i.memberKind, [...new Set((i.members || []).map(v => v.trim()).filter(Boolean))].sort()])
    : i.selectedId ? JSON.stringify([i.kind, i.selectedId]) : null;
  const audience = key(input);
  const demographics = t => JSON.stringify(Object.keys(DIMENSIONS).map(k => [...(t.targeting[k] || [])].sort()));
  return audience && draft.tests.find(t => t.id !== source.id &&
    t.inputs.filter(i => i.included).length === 1 &&
    key(t.inputs.find(i => i.included)) === audience && demographics(t) === demographics(source));
}
export function localErrors(draft, catalog) {
  const selected = draft.tests.filter(t => t.selected);
  const errors = [];
  for (const t of draft.tests.filter(t => t.ads.length > 10)) errors.push(`${t.name}: select at most 10 ads before saving.`);
  if (!selected.length) errors.push('Select at least one proposed ad group.');
  for (const t of selected) {
    if (!t.name.trim()) errors.push('Each ad group needs a name.');
    const inputs = t.inputs.filter(i => i.included);
    if (!inputs.length) errors.push(`${t.name}: choose an audience; demographics alone are blocked.`);
    for (const i of inputs.filter(i => i.kind === 'new_custom_segment')) {
      if (!i.value.trim() || !i.members?.some(v => v.trim())) errors.push(`${t.name}: name the new custom segment and add inputs.`);
      if (i.members?.filter(v => v.trim()).length > 50) errors.push(`${t.name}: use at most 50 inputs per custom segment.`);
      if (i.segmentType === 'SEARCH' && i.memberKind !== 'keyword') errors.push(`${t.name}: search segments need search terms.`);
    }
    if (inputs.some(i => i.kind !== 'new_custom_segment' && !i.selectedId)) errors.push(`${t.name}: resolve or deselect unmatched audience inputs.`);
    if (!t.ads.length) errors.push(`${t.name}: select at least one existing ad.`);
    if (catalog && t.ads.some(ref => !catalog.ads.some(a => a.resource === ref && !a.blocked))) errors.push(`${t.name}: an assigned ad is unavailable or incompatible.`);
  }
  return errors;
}
export function summary(draft) {
  const tests = draft.tests.filter(t => t.selected);
  return { tests, groups: tests.length, ads: tests.reduce((n, t) => n + t.ads.length, 0) };
}
